export default __webpack_public_path__ + "static/media/milestone 4200.60bf1a4a.svg";